// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.power-bi-reports-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);
  background-color: var(--color-bg-page);
}
.power-bi-reports-container .reports-content-area {
  display: flex;
  gap: 1.5rem;
  height: 100%;
  padding: 1rem;
}
.power-bi-reports-container .reports-content-area .reports-sidebar {
  width: 320px;
  background-color: var(--color-white);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow-y: auto;
  flex-shrink: 0;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .sidebar-header {
  padding: 1.5rem;
  border-bottom: 2px solid var(--color-border-light);
  background: var(--color-primary-green);
  border-radius: 12px 12px 0 0;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .sidebar-header h5 {
  margin: 0;
  font-weight: 600;
  color: var(--color-text-dark);
  font-size: 1.1rem;
  display: flex;
  align-items: center;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .sidebar-header h5 i {
  font-size: 1.2rem;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--color-border-light);
  cursor: pointer;
  transition: all 0.3s ease;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item:hover {
  background-color: var(--color-bg-hover);
  padding-left: 1.75rem;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item.active {
  background: var(--color-bg-panel);
  border-left: 4px solid var(--color-primary-green);
  padding-left: 1.5rem;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item.active .report-name {
  color: var(--color-text-dark);
  font-weight: 700;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item.active .report-arrow i {
  color: var(--color-primary-green);
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item .report-icon {
  width: 40px;
  height: 40px;
  background: var(--color-primary-green);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item .report-icon i {
  color: var(--color-text-dark);
  font-size: 1.2rem;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item .report-info {
  flex: 1 1;
  min-width: 0;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item .report-info .report-name {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-text-body);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item .report-info .report-description {
  margin: 0.25rem 0 0;
  font-size: 0.8rem;
  color: var(--color-menu-label);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item .report-arrow {
  margin-left: 0.5rem;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item .report-arrow i {
  color: var(--color-border-light);
  font-size: 0.9rem;
  transition: transform 0.3s ease;
}
.power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item:hover .report-arrow i {
  transform: translateX(4px);
  color: var(--color-primary-green);
}
.power-bi-reports-container .reports-content-area .report-display-area {
  flex: 1 1;
  background-color: var(--color-white);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.power-bi-reports-container .reports-content-area .report-display-area .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 3rem;
  text-align: center;
}
.power-bi-reports-container .reports-content-area .report-display-area .empty-state h4 {
  color: var(--color-text-body);
  margin-bottom: 0.5rem;
}
.power-bi-reports-container .reports-content-area .report-display-area .empty-state p {
  font-size: 1rem;
  color: var(--color-menu-label);
}
.power-bi-reports-container .reports-content-area .report-display-area .report-embed-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.power-bi-reports-container .reports-content-area .report-display-area .report-embed-container .report-header {
  padding: 1.5rem;
  border-bottom: 2px solid var(--color-border-light);
  background-color: var(--color-bg-hover);
}
.power-bi-reports-container .reports-content-area .report-display-area .report-embed-container .report-header h4 {
  margin: 0 0 0.5rem;
  color: var(--color-text-dark);
  font-weight: 700;
}
.power-bi-reports-container .reports-content-area .report-display-area .report-embed-container .report-header p {
  margin: 0;
  font-size: 0.95rem;
  color: var(--color-text-body);
}
.power-bi-reports-container .reports-content-area .report-display-area .report-embed-container .powerbi-frame {
  flex: 1 1;
  padding: 1rem;
  overflow: hidden;
}
.power-bi-reports-container .reports-content-area .report-display-area .report-embed-container .powerbi-frame .report-style-class {
  height: 100%;
  width: 100%;
  border: none;
  border-radius: 8px;
}
.power-bi-reports-container .report-sticky-header {
  position: fixed;
  top: 70px;
  right: 0;
  left: 250px;
  z-index: 999;
  background: var(--color-white);
  padding: 1rem 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid var(--color-primary-green);
  border-bottom: 2px solid var(--color-border-light);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: left 0.3s ease;
}
.power-bi-reports-container .report-sticky-header .report-header-content {
  display: flex;
  align-items: center;
  border-radius: 8px;
}
.power-bi-reports-container .report-sticky-header .report-header-content i {
  color: var(--color-text-dark);
  font-size: 1.5rem;
}
.power-bi-reports-container .report-sticky-header .report-header-content .report-title {
  margin: 0;
  color: var(--color-text-dark);
  font-size: 1.4rem;
  font-weight: 700;
  text-shadow: none;
}
.power-bi-reports-container .report-sticky-header .loading-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-primary-green);
  font-size: 0.95rem;
  font-weight: 600;
  background: var(--color-bg-panel);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  border: 2px solid var(--color-primary-green);
}
.power-bi-reports-container .report-sticky-header .loading-indicator .spinner-border {
  border-color: var(--color-primary-green);
  border-right-color: transparent;
}
.power-bi-reports-container .report-sticky-header .loading-indicator span {
  color: var(--color-primary-green);
}
@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.power-bi-reports-container .powerbi-content-container {
  display: flex;
  width: 100%;
  height: calc(100vh - 50px);
  margin-top: 0;
  margin-bottom: 0;
}
.power-bi-reports-container .powerbi-embed-wrapper {
  position: relative;
  overflow: auto;
}
.power-bi-reports-container .powerbi-report-container {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.power-bi-reports-container .powerbi-report-container iframe {
  border: none;
  border-radius: 8px;
  width: 100%;
  height: 100%;
}
.power-bi-reports-container .report-display-area .powerbi-report-container {
  min-height: 600px;
}
.power-bi-reports-container .alert {
  border-radius: 8px;
  border-left: 4px solid var(--color-link-blue);
  margin: 1rem;
}
.power-bi-reports-container .alert code {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.9rem;
}
.power-bi-reports-container .alert ul {
  padding-left: 1.5rem;
}
.power-bi-reports-container .alert ul li {
  margin-bottom: 0.25rem;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.main:has(.powerbi-layout) {
  padding-top: 0 !important;
  height: calc(100% - 35px) !important;
}

@media (min-width: 769px) {
  .topbar:has(~ .main .powerbi-layout),
  body:has(.powerbi-layout) .topbar {
    height: 45px !important;
  }
  .topbar:has(~ .main .powerbi-layout) .navbar,
  body:has(.powerbi-layout) .topbar .navbar {
    height: 45px !important;
  }
  .topbar:has(~ .main .powerbi-layout) .navbar .navbar-nav .nav-link,
  body:has(.powerbi-layout) .topbar .navbar .navbar-nav .nav-link {
    font-size: 18px !important;
  }
  .topbar:has(~ .main .powerbi-layout) .user-box,
  body:has(.powerbi-layout) .topbar .user-box {
    height: 45px !important;
    width: 40px !important;
  }
  .topbar:has(~ .main .powerbi-layout) .user-img,
  body:has(.powerbi-layout) .topbar .user-img {
    width: 32px !important;
    height: 32px !important;
  }
  .topbar:has(~ .main .powerbi-layout) .dropdown-user-img,
  body:has(.powerbi-layout) .topbar .dropdown-user-img {
    width: 32px !important;
    height: 32px !important;
    border-radius: 50%;
    background: var(--color-white);
    color: var(--color-primary-orange);
    font-size: 18px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
  .main:has(.powerbi-layout) {
    margin-top: 15px !important;
  }
}
.reports-home-page {
  padding: 2rem 3rem;
  max-width: 100%;
  margin: 0;
  background: var(--color-bg-page);
  min-height: calc(100vh - 70px);
}
.reports-home-page .home-header {
  margin-bottom: 2rem;
}
.reports-home-page .home-header .home-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--color-text-dark);
  margin-bottom: 0.5rem;
}
.reports-home-page .home-header .home-subtitle {
  font-size: 1rem;
  color: var(--color-menu-label);
  font-weight: 400;
}
.reports-home-page .continue-section {
  margin-bottom: 2rem;
}
.reports-home-page .continue-section .section-header {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--color-text-dark) !important;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
}
.reports-home-page .continue-section .last-viewed-card {
  background: var(--color-white);
  border-radius: 10px;
  padding: 1.25rem 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  border: 1px solid var(--color-border-light);
  border-left: 4px solid var(--color-primary-green);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
@media (hover: hover) and (pointer: fine) {
  .reports-home-page .continue-section .last-viewed-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}
.reports-home-page .continue-section .last-viewed-card .last-viewed-icon {
  width: 60px;
  height: 60px;
  background: var(--color-primary-green);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.reports-home-page .continue-section .last-viewed-card .last-viewed-icon i {
  font-size: 1.75rem;
  color: var(--color-text-dark);
}
.reports-home-page .continue-section .last-viewed-card .last-viewed-content {
  flex: 1 1;
}
.reports-home-page .continue-section .last-viewed-card .last-viewed-content .last-viewed-label {
  font-size: 0.75rem;
  color: var(--color-menu-label);
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
  display: block;
}
.reports-home-page .continue-section .last-viewed-card .last-viewed-content .last-viewed-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text-dark);
  margin: 0.25rem 0 0.5rem 0;
}
.reports-home-page .continue-section .last-viewed-card .last-viewed-content .last-viewed-time {
  font-size: 0.875rem;
  color: var(--color-text-body);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.375rem;
}
.reports-home-page .continue-section .last-viewed-card .last-viewed-content .last-viewed-time::before {
  content: "\\f017";
  font-family: "FontAwesome";
  font-size: 0.875rem;
}
.reports-home-page .continue-section .last-viewed-card .last-viewed-arrow {
  display: none;
}
.reports-home-page .recently-viewed-section {
  margin-bottom: 2rem;
}
.reports-home-page .recently-viewed-section .recently-viewed-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1rem;
}
.reports-home-page .recently-viewed-section .recently-viewed-header i {
  color: var(--color-primary-green);
  font-size: 1rem;
}
.reports-home-page .recently-viewed-section .recently-viewed-header span {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--color-menu-label);
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.reports-home-page .favorites-home-section {
  margin-bottom: 2rem;
}
.reports-home-page .favorites-home-section .favorites-home-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1rem;
}
.reports-home-page .favorites-home-section .favorites-home-header i {
  color: #faca00;
  font-size: 1rem;
}
.reports-home-page .favorites-home-section .favorites-home-header span {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--color-text-dark) !important;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.reports-home-page .favorites-home-section .favorites-home-header .favorites-count {
  margin-left: 4px;
  color: var(--color-text-dark) !important;
  font-size: 0.8125rem;
  font-weight: 600;
}
.reports-home-page .favorites-home-section .favorites-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}
@media (min-width: 1600px) {
  .reports-home-page .favorites-home-section .favorites-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
.reports-home-page .favorites-home-section .favorites-grid .favorite-card {
  background: var(--color-white);
  border: 1px solid var(--color-border-light);
  border-radius: 10px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
@media (hover: hover) and (pointer: fine) {
  .reports-home-page .favorites-home-section .favorites-grid .favorite-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: var(--color-primary-green);
  }
}
.reports-home-page .favorites-home-section .favorites-grid .favorite-card .favorite-card-icon {
  width: 44px;
  height: 44px;
  background: var(--color-bg-panel);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reports-home-page .favorites-home-section .favorites-grid .favorite-card .favorite-card-icon i {
  font-size: 1.25rem;
  color: var(--color-primary-green);
}
.reports-home-page .favorites-home-section .favorites-grid .favorite-card .favorite-card-content {
  flex: 1 1;
}
.reports-home-page .favorites-home-section .favorites-grid .favorite-card .favorite-card-content .favorite-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-text-dark);
  margin: 0 0 0.375rem 0;
}
.reports-home-page .favorites-home-section .favorites-grid .favorite-card .favorite-card-content .favorite-card-description {
  font-size: 0.8125rem;
  color: var(--color-menu-label);
  margin: 0;
  line-height: 1.4;
}
.reports-home-page .favorites-home-section .favorites-grid .favorite-card .favorite-card-star {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.reports-home-page .favorites-home-section .favorites-grid .favorite-card .favorite-card-star i {
  color: #faca00;
  font-size: 1rem;
}
.reports-home-page .no-favorites {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--color-menu-label);
}
.reports-home-page .no-favorites i {
  font-size: 4rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}
.reports-home-page .no-favorites p {
  font-size: 1.125rem;
  margin: 0;
}

@media (max-width: 1200px) {
  .power-bi-reports-container .reports-content-area .reports-sidebar {
    width: 280px;
  }
}
@media (max-width: 992px) {
  .power-bi-reports-container .reports-content-area {
    flex-direction: column;
    height: auto;
  }
  .power-bi-reports-container .reports-content-area .reports-sidebar {
    width: 100%;
    max-height: 300px;
  }
  .power-bi-reports-container .reports-content-area .report-display-area {
    min-height: 600px;
  }
}
@media (max-width: 768px) {
  .main:has(.powerbi-layout) {
    margin-top: 45px !important;
    height: calc(100% - 45px) !important;
  }
  .reports-home-page {
    padding: 1rem;
    margin-top: 0;
    min-height: calc(100% - 45px) !important;
    height: auto;
    overflow-y: auto;
  }
  .reports-home-page .home-header {
    margin-bottom: 2rem;
  }
  .reports-home-page .home-header .home-title {
    font-size: 2rem;
  }
  .reports-home-page .home-header .home-subtitle {
    font-size: 1rem;
  }
  .reports-home-page .favorites-home-section .favorites-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .reports-home-page .no-favorites {
    padding: 3rem 1rem;
  }
  .reports-home-page .no-favorites i {
    font-size: 3rem;
  }
  .reports-home-page .no-favorites p {
    font-size: 1rem;
  }
  .power-bi-reports-container .reports-content-area {
    gap: 1rem;
    padding: 0.5rem;
  }
  .power-bi-reports-container .reports-content-area .reports-sidebar .sidebar-header {
    padding: 1rem;
  }
  .power-bi-reports-container .reports-content-area .reports-sidebar .sidebar-header h5 {
    font-size: 1rem;
  }
  .power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item {
    padding: 0.75rem 1rem;
  }
  .power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item .report-icon {
    width: 35px;
    height: 35px;
  }
  .power-bi-reports-container .reports-content-area .reports-sidebar .reports-list .report-item .report-icon i {
    font-size: 1rem;
  }
  .power-bi-reports-container .report-sticky-header {
    left: 200px;
    padding: 0.75rem 1.25rem;
  }
  .power-bi-reports-container .report-sticky-header .report-header-content {
    padding: 0.4rem 0.75rem;
  }
  .power-bi-reports-container .report-sticky-header .report-header-content .report-title {
    font-size: 1.1rem;
  }
  .power-bi-reports-container .report-sticky-header .report-header-content i {
    font-size: 1.2rem;
  }
  .power-bi-reports-container .report-sticky-header .loading-indicator {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }
}
@media (max-width: 768px) {
  .main {
    padding: 0 !important;
    margin-left: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .power-bi-reports-container {
    padding: 0 !important;
    width: 100vw !important;
    height: calc(100vh - 55px) !important;
    margin: 0 !important;
    overflow-x: hidden !important;
  }
  .power-bi-reports-container.has-mobile-sticky-header {
    height: calc(100vh - 105px) !important;
  }
  .power-bi-reports-container.has-mobile-sticky-header .powerbi-content-container {
    height: calc(100vh - 105px) !important;
  }
  .power-bi-reports-container.has-mobile-sticky-header .powerbi-embed-wrapper {
    height: calc(100vh - 105px) !important;
  }
  .power-bi-reports-container .report-sticky-header {
    position: fixed !important;
    left: 0 !important;
    right: 0 !important;
    top: 40px !important;
    width: 100vw !important;
    max-width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
    flex-direction: row;
    flex-wrap: nowrap;
    border-left: none !important;
    border-bottom: 1px solid var(--color-border-light);
    min-height: 45px;
    box-sizing: border-box;
    transition: none !important;
    z-index: 998;
    background: var(--color-white) !important;
    display: flex;
    transform: translate3d(0, 0, 0);
  }
  .power-bi-reports-container .report-sticky-header .report-header-content {
    flex: 1 1;
    padding: 0.5rem 0.75rem;
    gap: 0.5rem;
    min-width: 0;
  }
  .power-bi-reports-container .report-sticky-header .report-header-content .report-title {
    font-size: 0.85rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: none;
  }
  .power-bi-reports-container .report-sticky-header .report-header-content i {
    font-size: 0.9rem;
    flex-shrink: 0;
  }
  .power-bi-reports-container .report-sticky-header button {
    font-size: 0.75rem !important;
    padding: 6px 8px !important;
    margin-right: 0.75rem !important;
    flex-shrink: 0;
  }
  .power-bi-reports-container .report-sticky-header button i {
    font-size: 1rem !important;
  }
  .power-bi-reports-container .report-sticky-header .loading-indicator {
    font-size: 0.75rem;
    padding: 0.3rem 0.6rem;
    margin-right: 0.75rem;
  }
  .power-bi-reports-container:not(.has-mobile-sticky-header) .powerbi-content-container {
    height: calc(100vh - 55px) !important;
  }
  .power-bi-reports-container:not(.has-mobile-sticky-header) .powerbi-embed-wrapper {
    margin-top: 5px !important;
    height: calc(100vh - 280px) !important;
    padding: 0 !important;
    width: 100% !important;
    margin-bottom: 20px;
    overflow: visible !important;
  }
}
@media (min-width: 769px) {
  .powerbi-layout:has(.reports-menu.collapsed) .report-sticky-header {
    left: 60px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/PowerBIPortal.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,sCAAA;AACF;AACE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AACJ;AAEI;EACE,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,cAAA;AAAN;AAEM;EACE,eAAA;EACA,kDAAA;EACA,sCAAA;EACA,4BAAA;AAAR;AAEQ;EACE,SAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAAV;AAEU;EACE,iBAAA;AAAZ;AAMQ;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kDAAA;EACA,eAAA;EACA,yBAAA;AAJV;AAMU;EACE,uCAAA;EACA,qBAAA;AAJZ;AAOU;EACE,iCAAA;EACA,iDAAA;EACA,oBAAA;AALZ;AAOY;EACE,6BAAA;EACA,gBAAA;AALd;AAQY;EACE,iCAAA;AANd;AAUU;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AARZ;AAUY;EACE,6BAAA;EACA,iBAAA;AARd;AAYU;EACE,SAAA;EACA,YAAA;AAVZ;AAYY;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAVd;AAaY;EACE,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAXd;AAeU;EACE,mBAAA;AAbZ;AAeY;EACE,gCAAA;EACA,iBAAA;EACA,+BAAA;AAbd;AAiBU;EACE,0BAAA;EACA,iCAAA;AAfZ;AAsBI;EACE,SAAA;EACA,oCAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AApBN;AAsBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AApBR;AAsBQ;EACE,6BAAA;EACA,qBAAA;AApBV;AAuBQ;EACE,eAAA;EACA,8BAAA;AArBV;AAyBM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAvBR;AAyBQ;EACE,eAAA;EACA,kDAAA;EACA,uCAAA;AAvBV;AAyBU;EACE,kBAAA;EACA,6BAAA;EACA,gBAAA;AAvBZ;AA0BU;EACE,SAAA;EACA,kBAAA;EACA,6BAAA;AAxBZ;AA4BQ;EACE,SAAA;EACA,aAAA;EACA,gBAAA;AA1BV;AA4BU;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA1BZ;AAkCE;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,wCAAA;EACA,iDAAA;EACA,kDAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;AAhCJ;AAkCI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAhCN;AAkCM;EACE,6BAAA;EACA,iBAAA;AAhCR;AAmCM;EACE,SAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAjCR;AAqCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,oBAAA;EACA,mBAAA;EACA,4CAAA;AAnCN;AAqCM;EACE,wCAAA;EACA,+BAAA;AAnCR;AAsCM;EACE,iCAAA;AApCR;AAyCE;EACE;IACE,4BAAA;IACA,UAAA;EAvCJ;EAyCE;IACE,wBAAA;IACA,UAAA;EAvCJ;AACF;AA0CE;EACE,aAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,gBAAA;AAxCJ;AA2CE;EACE,kBAAA;EACA,cAAA;AAzCJ;AA4CE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;AA1CJ;AA4CI;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AA1CN;AA+CI;EACE,iBAAA;AA7CN;AAiDE;EACE,kBAAA;EACA,6CAAA;EACA,YAAA;AA/CJ;AAiDI;EACE,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AA/CN;AAkDI;EACE,oBAAA;AAhDN;AAkDM;EACE,sBAAA;AAhDR;;AAsDA;EACE;IACE,UAAA;IACA,2BAAA;EAnDF;EAqDA;IACE,UAAA;IACA,wBAAA;EAnDF;AACF;AAsDA;EACE,yBAAA;EACA,oCAAA;AApDF;;AAuDA;EACE;;IAEE,uBAAA;EApDF;EAsDE;;IACE,uBAAA;EAnDJ;EAsDE;;IACE,0BAAA;EAnDJ;EAsDE;;IACE,uBAAA;IACA,sBAAA;EAnDJ;EAsDE;;IACE,sBAAA;IACA,uBAAA;EAnDJ;EAsDE;;IACE,sBAAA;IACA,uBAAA;IACA,kBAAA;IACA,8BAAA;IACA,kCAAA;IACA,0BAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,UAAA;EAnDJ;EAuDA;IACE,2BAAA;EArDF;AACF;AAyDA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gCAAA;EACA,8BAAA;AAvDF;AAyDE;EACE,mBAAA;AAvDJ;AAyDI;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;AAvDN;AA0DI;EACE,eAAA;EACA,8BAAA;EACA,gBAAA;AAxDN;AA4DE;EACE,mBAAA;AA1DJ;AA4DI;EACE,oBAAA;EACA,gBAAA;EACA,wCAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AA1DN;AA6DI;EACE,8BAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,wCAAA;EACA,0BAAA;AA3DN;AA8DM;EACE;IACE,2BAAA;IACA,yCAAA;EA5DR;AACF;AA+DM;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA7DR;AA+DQ;EACE,kBAAA;EACA,6BAAA;AA7DV;AAiEM;EACE,SAAA;AA/DR;AAiEQ;EACE,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AA/DV;AAkEQ;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,0BAAA;AAhEV;AAmEQ;EACE,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AAjEV;AAmEU;EACE,gBAAA;EACA,0BAAA;EACA,mBAAA;AAjEZ;AAsEM;EACE,aAAA;AApER;AAyEE;EACE,mBAAA;AAvEJ;AAyEI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAvEN;AAyEM;EACE,iCAAA;EACA,eAAA;AAvER;AA0EM;EACE,oBAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;AAxER;AA6EE;EACE,mBAAA;AA3EJ;AA6EI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA3EN;AA6EM;EACE,cAAA;EACA,eAAA;AA3ER;AA8EM;EACE,oBAAA;EACA,gBAAA;EACA,wCAAA;EACA,sBAAA;EACA,yBAAA;AA5ER;AA+EM;EACE,gBAAA;EACA,wCAAA;EACA,oBAAA;EACA,gBAAA;AA7ER;AAiFI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AA/EN;AAiFM;EALF;IAMI,qCAAA;EA9EN;AACF;AAgFM;EACE,8BAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,0BAAA;AA9ER;AAiFQ;EACE;IACE,2BAAA;IACA,0CAAA;IACA,wCAAA;EA/EV;AACF;AAkFQ;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhFV;AAkFU;EACE,kBAAA;EACA,iCAAA;AAhFZ;AAoFQ;EACE,SAAA;AAlFV;AAoFU;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,sBAAA;AAlFZ;AAqFU;EACE,oBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAnFZ;AAuFQ;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AArFV;AAuFU;EACE,cAAA;EACA,eAAA;AArFZ;AA4FE;EACE,kBAAA;EACA,kBAAA;EACA,8BAAA;AA1FJ;AA4FI;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AA1FN;AA6FI;EACE,mBAAA;EACA,SAAA;AA3FN;;AAiGA;EAGM;IACE,YAAA;EAhGN;AACF;AAqGA;EAEI;IACE,sBAAA;IACA,YAAA;EApGJ;EAsGI;IACE,WAAA;IACA,iBAAA;EApGN;EAuGI;IACE,iBAAA;EArGN;AACF;AA0GA;EAEE;IACE,2BAAA;IACA,oCAAA;EAzGF;EA2GA;IACE,aAAA;IACA,aAAA;IACA,wCAAA;IACA,YAAA;IACA,gBAAA;EAzGF;EA2GE;IACE,mBAAA;EAzGJ;EA2GI;IACE,eAAA;EAzGN;EA4GI;IACE,eAAA;EA1GN;EA+GI;IACE,0BAAA;IACA,SAAA;EA7GN;EAiHE;IACE,kBAAA;EA/GJ;EAiHI;IACE,eAAA;EA/GN;EAkHI;IACE,eAAA;EAhHN;EAsHE;IACE,SAAA;IACA,eAAA;EApHJ;EAuHM;IACE,aAAA;EArHR;EAuHQ;IACE,eAAA;EArHV;EA0HQ;IACE,qBAAA;EAxHV;EA0HU;IACE,WAAA;IACA,YAAA;EAxHZ;EA0HY;IACE,eAAA;EAxHd;EAgIE;IACE,WAAA;IACA,wBAAA;EA9HJ;EAgII;IACE,uBAAA;EA9HN;EAgIM;IACE,iBAAA;EA9HR;EAiIM;IACE,iBAAA;EA/HR;EAmII;IACE,kBAAA;IACA,sBAAA;EAjIN;AACF;AAsIA;EACE;IACE,qBAAA;IACA,yBAAA;IACA,wBAAA;IACA,2BAAA;EApIF;EAuIA;IACE,qBAAA;IACA,uBAAA;IACA,qCAAA;IACA,oBAAA;IACA,6BAAA;EArIF;EAwIE;IACE,sCAAA;EAtIJ;EAwII;IACE,sCAAA;EAtIN;EAyII;IACE,sCAAA;EAvIN;EA2IE;IACE,0BAAA;IACA,kBAAA;IACA,mBAAA;IACA,oBAAA;IACA,uBAAA;IACA,2BAAA;IACA,oBAAA;IACA,qBAAA;IACA,mBAAA;IACA,iBAAA;IACA,4BAAA;IACA,kDAAA;IACA,gBAAA;IACA,sBAAA;IACA,2BAAA;IACA,YAAA;IACA,yCAAA;IACA,aAAA;IAEA,+BAAA;EAzIJ;EA2II;IACE,SAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;EAzIN;EA2IM;IACE,kBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,aAAA;EAzIR;EA4IM;IACE,iBAAA;IACA,cAAA;EA1IR;EA8II;IACE,6BAAA;IACA,2BAAA;IACA,gCAAA;IACA,cAAA;EA5IN;EA8IM;IACE,0BAAA;EA5IR;EAgJI;IACE,kBAAA;IACA,sBAAA;IACA,qBAAA;EA9IN;EAoJI;IACE,qCAAA;EAlJN;EAqJI;IACE,0BAAA;IACA,sCAAA;IACA,qBAAA;IACA,sBAAA;IACA,mBAAA;IACA,4BAAA;EAnJN;AACF;AAwJA;EAEI;IACE,qBAAA;EAvJJ;AACF","sourcesContent":[".power-bi-reports-container {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 50px);\n  background-color: var(--color-bg-page);\n\n  .reports-content-area {\n    display: flex;\n    gap: 1.5rem;\n    height: 100%;\n    padding: 1rem;\n\n    // Reports Sidebar\n    .reports-sidebar {\n      width: 320px;\n      background-color: var(--color-white);\n      border-radius: 12px;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n      overflow-y: auto;\n      flex-shrink: 0;\n\n      .sidebar-header {\n        padding: 1.5rem;\n        border-bottom: 2px solid var(--color-border-light);\n        background: var(--color-primary-green);\n        border-radius: 12px 12px 0 0;\n\n        h5 {\n          margin: 0;\n          font-weight: 600;\n          color: var(--color-text-dark);\n          font-size: 1.1rem;\n          display: flex;\n          align-items: center;\n\n          i {\n            font-size: 1.2rem;\n          }\n        }\n      }\n\n      .reports-list {\n        .report-item {\n          display: flex;\n          align-items: center;\n          padding: 1rem 1.5rem;\n          border-bottom: 1px solid var(--color-border-light);\n          cursor: pointer;\n          transition: all 0.3s ease;\n\n          &:hover {\n            background-color: var(--color-bg-hover);\n            padding-left: 1.75rem;\n          }\n\n          &.active {\n            background: var(--color-bg-panel);\n            border-left: 4px solid var(--color-primary-green);\n            padding-left: 1.5rem;\n\n            .report-name {\n              color: var(--color-text-dark);\n              font-weight: 700;\n            }\n\n            .report-arrow i {\n              color: var(--color-primary-green);\n            }\n          }\n\n          .report-icon {\n            width: 40px;\n            height: 40px;\n            background: var(--color-primary-green);\n            border-radius: 8px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-right: 1rem;\n            flex-shrink: 0;\n\n            i {\n              color: var(--color-text-dark);\n              font-size: 1.2rem;\n            }\n          }\n\n          .report-info {\n            flex: 1;\n            min-width: 0;\n\n            .report-name {\n              margin: 0;\n              font-size: 0.95rem;\n              font-weight: 600;\n              color: var(--color-text-body);\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }\n\n            .report-description {\n              margin: 0.25rem 0 0;\n              font-size: 0.8rem;\n              color: var(--color-menu-label);\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }\n          }\n\n          .report-arrow {\n            margin-left: 0.5rem;\n\n            i {\n              color: var(--color-border-light);\n              font-size: 0.9rem;\n              transition: transform 0.3s ease;\n            }\n          }\n\n          &:hover .report-arrow i {\n            transform: translateX(4px);\n            color: var(--color-primary-green);\n          }\n        }\n      }\n    }\n\n    // Report Display Area\n    .report-display-area {\n      flex: 1;\n      background-color: var(--color-white);\n      border-radius: 12px;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n      overflow: hidden;\n      display: flex;\n      flex-direction: column;\n\n      .empty-state {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n        padding: 3rem;\n        text-align: center;\n\n        h4 {\n          color: var(--color-text-body);\n          margin-bottom: 0.5rem;\n        }\n\n        p {\n          font-size: 1rem;\n          color: var(--color-menu-label);\n        }\n      }\n\n      .report-embed-container {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n\n        .report-header {\n          padding: 1.5rem;\n          border-bottom: 2px solid var(--color-border-light);\n          background-color: var(--color-bg-hover);\n\n          h4 {\n            margin: 0 0 0.5rem;\n            color: var(--color-text-dark);\n            font-weight: 700;\n          }\n\n          p {\n            margin: 0;\n            font-size: 0.95rem;\n            color: var(--color-text-body);\n          }\n        }\n\n        .powerbi-frame {\n          flex: 1;\n          padding: 1rem;\n          overflow: hidden;\n\n          .report-style-class {\n            height: 100%;\n            width: 100%;\n            border: none;\n            border-radius: 8px;\n          }\n        }\n      }\n    }\n  }\n\n  // Sticky Header for Report\n  .report-sticky-header {\n    position: fixed;\n    top: 70px;\n    right: 0;\n    left: 250px;\n    z-index: 999;\n    background: var(--color-white);\n    padding: 1rem 2rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    border-left: 4px solid var(--color-primary-green);\n    border-bottom: 2px solid var(--color-border-light);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: left 0.3s ease;\n\n    .report-header-content {\n      display: flex;\n      align-items: center;\n      border-radius: 8px;\n\n      i {\n        color: var(--color-text-dark);\n        font-size: 1.5rem;\n      }\n\n      .report-title {\n        margin: 0;\n        color: var(--color-text-dark);\n        font-size: 1.4rem;\n        font-weight: 700;\n        text-shadow: none;\n      }\n    }\n\n    .loading-indicator {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      color: var(--color-primary-green);\n      font-size: 0.95rem;\n      font-weight: 600;\n      background: var(--color-bg-panel);\n      padding: 0.5rem 1rem;\n      border-radius: 20px;\n      border: 2px solid var(--color-primary-green);\n\n      .spinner-border {\n        border-color: var(--color-primary-green);\n        border-right-color: transparent;\n      }\n\n      span {\n        color: var(--color-primary-green);\n      }\n    }\n  }\n\n  @keyframes slideDown {\n    from {\n      transform: translateY(-100%);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n\n  .powerbi-content-container {\n    display: flex;\n    width: 100%;\n    height: calc(100vh - 50px);\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .powerbi-embed-wrapper {\n    position: relative;\n    overflow: auto;\n  }\n\n  .powerbi-report-container {\n    width: 100%;\n    height: 100%;\n    border: none;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n\n    iframe {\n      border: none;\n      border-radius: 8px;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .report-display-area {\n    .powerbi-report-container {\n      min-height: 600px;\n    }\n  }\n\n  .alert {\n    border-radius: 8px;\n    border-left: 4px solid var(--color-link-blue);\n    margin: 1rem;\n\n    code {\n      background-color: rgba(0, 0, 0, 0.05);\n      padding: 2px 6px;\n      border-radius: 4px;\n      font-size: 0.9rem;\n    }\n\n    ul {\n      padding-left: 1.5rem;\n\n      li {\n        margin-bottom: 0.25rem;\n      }\n    }\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.main:has(.powerbi-layout) {\n  padding-top: 0 !important;\n  height: calc(100% - 35px) !important;\n}\n\n@media (min-width: 769px) {\n  .topbar:has(~ .main .powerbi-layout),\n  body:has(.powerbi-layout) .topbar {\n    height: 45px !important;\n\n    .navbar {\n      height: 45px !important;\n    }\n\n    .navbar .navbar-nav .nav-link {\n      font-size: 18px !important;\n    }\n\n    .user-box {\n      height: 45px !important;\n      width: 40px !important;\n    }\n\n    .user-img {\n      width: 32px !important;\n      height: 32px !important;\n    }\n\n    .dropdown-user-img {\n      width: 32px !important;\n      height: 32px !important;\n      border-radius: 50%;\n      background: var(--color-white);\n      color: var(--color-primary-orange);\n      font-size: 18px !important;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0;\n    }\n  }\n\n  .main:has(.powerbi-layout) {\n    margin-top: 15px !important;\n  }\n}\n\n// Reports Home Page Styles\n.reports-home-page {\n  padding: 2rem 3rem;\n  max-width: 100%;\n  margin: 0;\n  background: var(--color-bg-page);\n  min-height: calc(100vh - 70px);\n\n  .home-header {\n    margin-bottom: 2rem;\n\n    .home-title {\n      font-size: 2rem;\n      font-weight: 700;\n      color: var(--color-text-dark);\n      margin-bottom: 0.5rem;\n    }\n\n    .home-subtitle {\n      font-size: 1rem;\n      color: var(--color-menu-label);\n      font-weight: 400;\n    }\n  }\n\n  .continue-section {\n    margin-bottom: 2rem;\n\n    .section-header {\n      font-size: 0.8125rem;\n      font-weight: 600;\n      color: var(--color-text-dark) !important;\n      letter-spacing: 0.05em;\n      text-transform: uppercase;\n      margin-bottom: 0.75rem;\n    }\n\n    .last-viewed-card {\n      background: var(--color-white);\n      border-radius: 10px;\n      padding: 1.25rem 1.5rem;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      gap: 1.25rem;\n      border: 1px solid var(--color-border-light);\n      border-left: 4px solid var(--color-primary-green);\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n      -webkit-tap-highlight-color: transparent;\n      touch-action: manipulation;\n\n      // Only apply hover effects on non-touch devices\n      @media (hover: hover) and (pointer: fine) {\n        &:hover {\n          transform: translateY(-1px);\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n        }\n      }\n\n      .last-viewed-icon {\n        width: 60px;\n        height: 60px;\n        background: var(--color-primary-green);\n        border-radius: 10px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n\n        i {\n          font-size: 1.75rem;\n          color: var(--color-text-dark);\n        }\n      }\n\n      .last-viewed-content {\n        flex: 1;\n\n        .last-viewed-label {\n          font-size: 0.75rem;\n          color: var(--color-menu-label);\n          font-weight: 500;\n          letter-spacing: 0.05em;\n          text-transform: uppercase;\n          margin-bottom: 0.25rem;\n          display: block;\n        }\n\n        .last-viewed-title {\n          font-size: 1.25rem;\n          font-weight: 600;\n          color: var(--color-text-dark);\n          margin: 0.25rem 0 0.5rem 0;\n        }\n\n        .last-viewed-time {\n          font-size: 0.875rem;\n          color: var(--color-text-body);\n          margin: 0;\n          display: flex;\n          align-items: center;\n          gap: 0.375rem;\n\n          &::before {\n            content: '\\f017';\n            font-family: 'FontAwesome';\n            font-size: 0.875rem;\n          }\n        }\n      }\n\n      .last-viewed-arrow {\n        display: none;\n      }\n    }\n  }\n\n  .recently-viewed-section {\n    margin-bottom: 2rem;\n\n    .recently-viewed-header {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 1rem;\n\n      i {\n        color: var(--color-primary-green);\n        font-size: 1rem;\n      }\n\n      span {\n        font-size: 0.8125rem;\n        font-weight: 600;\n        color: var(--color-menu-label);\n        letter-spacing: 0.05em;\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  .favorites-home-section {\n    margin-bottom: 2rem;\n\n    .favorites-home-header {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 1rem;\n\n      i {\n        color: #faca00;\n        font-size: 1rem;\n      }\n\n      span {\n        font-size: 0.8125rem;\n        font-weight: 600;\n        color: var(--color-text-dark) !important;\n        letter-spacing: 0.05em;\n        text-transform: uppercase;\n      }\n\n      .favorites-count {\n        margin-left: 4px;\n        color: var(--color-text-dark) !important;\n        font-size: 0.8125rem;\n        font-weight: 600;\n      }\n    }\n\n    .favorites-grid {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 1rem;\n\n      @media (min-width: 1600px) {\n        grid-template-columns: repeat(3, 1fr);\n      }\n\n      .favorite-card {\n        background: var(--color-white);\n        border: 1px solid var(--color-border-light);\n        border-radius: 10px;\n        padding: 1.25rem;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        display: flex;\n        flex-direction: column;\n        gap: 0.875rem;\n        position: relative;\n        -webkit-tap-highlight-color: transparent;\n        touch-action: manipulation;\n\n        // Only apply hover effects on non-touch devices\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n            border-color: var(--color-primary-green);\n          }\n        }\n\n        .favorite-card-icon {\n          width: 44px;\n          height: 44px;\n          background: var(--color-bg-panel);\n          border-radius: 8px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          i {\n            font-size: 1.25rem;\n            color: var(--color-primary-green);\n          }\n        }\n\n        .favorite-card-content {\n          flex: 1;\n\n          .favorite-card-title {\n            font-size: 1rem;\n            font-weight: 600;\n            color: var(--color-text-dark);\n            margin: 0 0 0.375rem 0;\n          }\n\n          .favorite-card-description {\n            font-size: 0.8125rem;\n            color: var(--color-menu-label);\n            margin: 0;\n            line-height: 1.4;\n          }\n        }\n\n        .favorite-card-star {\n          position: absolute;\n          top: 1rem;\n          right: 1rem;\n\n          i {\n            color: #faca00;\n            font-size: 1rem;\n          }\n        }\n      }\n    }\n  }\n\n  .no-favorites {\n    text-align: center;\n    padding: 4rem 2rem;\n    color: var(--color-menu-label);\n\n    i {\n      font-size: 4rem;\n      margin-bottom: 1rem;\n      opacity: 0.5;\n    }\n\n    p {\n      font-size: 1.125rem;\n      margin: 0;\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 1200px) {\n  .power-bi-reports-container {\n    .reports-content-area {\n      .reports-sidebar {\n        width: 280px;\n      }\n    }\n  }\n}\n\n@media (max-width: 992px) {\n  .power-bi-reports-container {\n    .reports-content-area {\n      flex-direction: column;\n      height: auto;\n\n      .reports-sidebar {\n        width: 100%;\n        max-height: 300px;\n      }\n\n      .report-display-area {\n        min-height: 600px;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  // Mobile styles for home page\n  .main:has(.powerbi-layout) {\n    margin-top:45px !important;\n    height: calc(100% - 45px) !important;\n  }\n  .reports-home-page {\n    padding: 1rem;\n    margin-top: 0;\n    min-height: calc(100% - 45px) !important;\n    height: auto;\n    overflow-y: auto;\n\n    .home-header {\n      margin-bottom: 2rem;\n\n      .home-title {\n        font-size: 2rem;\n      }\n\n      .home-subtitle {\n        font-size: 1rem;\n      }\n    }\n\n    .favorites-home-section {\n      .favorites-grid {\n        grid-template-columns: 1fr;\n        gap: 1rem;\n      }\n    }\n\n    .no-favorites {\n      padding: 3rem 1rem;\n\n      i {\n        font-size: 3rem;\n      }\n\n      p {\n        font-size: 1rem;\n      }\n    }\n  }\n\n  .power-bi-reports-container {\n    .reports-content-area {\n      gap: 1rem;\n      padding: 0.5rem;\n\n      .reports-sidebar {\n        .sidebar-header {\n          padding: 1rem;\n\n          h5 {\n            font-size: 1rem;\n          }\n        }\n\n        .reports-list {\n          .report-item {\n            padding: 0.75rem 1rem;\n\n            .report-icon {\n              width: 35px;\n              height: 35px;\n\n              i {\n                font-size: 1rem;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .report-sticky-header {\n      left: 200px;\n      padding: 0.75rem 1.25rem;\n\n      .report-header-content {\n        padding: 0.4rem 0.75rem;\n\n        .report-title {\n          font-size: 1.1rem;\n        }\n\n        i {\n          font-size: 1.2rem;\n        }\n      }\n\n      .loading-indicator {\n        font-size: 0.85rem;\n        padding: 0.4rem 0.8rem;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .main {\n    padding: 0 !important;\n    margin-left: 0 !important;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .power-bi-reports-container {\n    padding: 0 !important;\n    width: 100vw !important;\n    height: calc(100vh - 55px) !important; // Full height minus main header\n    margin: 0 !important;\n    overflow-x: hidden !important;\n\n    // Adjust layout when report sticky header is visible on mobile\n    &.has-mobile-sticky-header {\n      height: calc(100vh - 105px) !important;\n\n      .powerbi-content-container {\n        height: calc(100vh - 105px) !important;\n      }\n\n      .powerbi-embed-wrapper {\n        height: calc(100vh - 105px) !important;\n      }\n    }\n\n    .report-sticky-header {\n      position: fixed !important;\n      left: 0 !important;\n      right: 0 !important;\n      top: 40px !important;\n      width: 100vw !important;\n      max-width: 100vw !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      border-left: none !important;\n      border-bottom: 1px solid var(--color-border-light);\n      min-height: 45px;\n      box-sizing: border-box;\n      transition: none !important;\n      z-index: 998;\n      background: var(--color-white) !important;\n      display: flex;\n      -webkit-transform: translate3d(0, 0, 0);\n      transform: translate3d(0, 0, 0);\n\n      .report-header-content {\n        flex: 1;\n        padding: 0.5rem 0.75rem;\n        gap: 0.5rem;\n        min-width: 0;\n\n        .report-title {\n          font-size: 0.85rem;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          display:none;\n        }\n\n        i {\n          font-size: 0.9rem;\n          flex-shrink: 0;\n        }\n      }\n\n      button {\n        font-size: 0.75rem !important;\n        padding: 6px 8px !important;\n        margin-right: 0.75rem !important;\n        flex-shrink: 0;\n\n        i {\n          font-size: 1rem !important;\n        }\n      }\n\n      .loading-indicator {\n        font-size: 0.75rem;\n        padding: 0.3rem 0.6rem;\n        margin-right: 0.75rem;\n      }\n    }\n\n    // Default styles when sticky header is NOT shown\n    &:not(.has-mobile-sticky-header) {\n      .powerbi-content-container {\n        height: calc(100vh - 55px) !important; // Mobile: Full viewport minus minimal header\n      }\n\n      .powerbi-embed-wrapper {\n        margin-top: 5px !important;\n        height: calc(100vh - 280px) !important;\n        padding: 0 !important;\n        width: 100% !important;\n        margin-bottom: 20px;\n        overflow: visible !important;\n      }\n    }\n  }\n}\n\n@media (min-width: 769px) {\n  .powerbi-layout:has(.reports-menu.collapsed) {\n    .report-sticky-header {\n      left: 60px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
